module.exports = __webpack_public_path__ + "img/4.79a30b5d.png";